import { render, staticRenderFns } from "./email-editor.vue?vue&type=template&id=15e024ee&scoped=true"
import script from "./email-editor.vue?vue&type=script&lang=js"
export * from "./email-editor.vue?vue&type=script&lang=js"
import style0 from "./email-editor.vue?vue&type=style&index=0&id=15e024ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e024ee",
  null
  
)

export default component.exports